import react from 'react';

export class AsideLayout extends react.Component {
  constructor(props) {
    super(props);
    this.state = { header: props.header  };
  }

  render() {
    return <div className="aside-block">
    <div className="aside-content-container">
      <div className="aside-content">
        <div>
          <h1 className="h2-size heading mb-6 mt-4">
            {this.state.header}
          </h1>
          <form>
            {this.props.children}
          </form>
        </div>
      </div>
    </div>
  </div>
  }
}